var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoProducts = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F68DCCE6-6326-42BF-9865-0D4444C2B1A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-wiki-Details",
    transform: "translate(-497.000000, -456.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-topic",
    transform: "translate(100.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(380.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_products",
    transform: "translate(17.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "6.84 12.904 12.84 12.904 12.84 10.904 6.84 10.904"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "17.2805 7.293 15.8665 8.707 17.0645 9.904 14.4885 9.904 14.4885 11.904 17.5495 11.904 17.5015 15.602 15.5375 15.602 15.5415 13.964 4.1825 13.964 4.1595 15.602 2.4265 15.602 2.4265 11.904 5.1915 11.904 5.1915 9.904 2.9365 9.904 4.1345 8.707 2.7195 7.293 0.4265 9.586 0.4265 17.602 6.1305 17.602 6.1535 15.964 13.5375 15.964 13.5335 17.602 19.4755 17.602 19.5785 9.591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8684,4.7114 C10.3084,4.7844 12.9184,3.8484 14.1794,2.0974 L16.5634,2.0974 C14.9634,4.7244 11.6114,6.1694 7.0604,6.1694 C6.9974,6.1694 6.9324,6.1694 6.8684,6.1684 L6.8684,4.7114 Z M7.0654,8.1694 C13.2364,8.1694 17.5814,5.7484 19.0774,1.4244 L19.5364,0.0974 L13.0154,0.0974 L12.7354,0.6364 C11.9424,2.1624 9.4024,2.9194 5.9414,2.6674 L4.8684,2.5874 L4.8684,8.0894 L5.8184,8.1374 C6.2414,8.1584 6.6574,8.1694 7.0654,8.1694 L7.0654,8.1694 Z",
    id: "Fill-5"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoProducts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_products.be4c0d6fa6eaaea33319e9385d9879ee.svg";